<script
    src="../../../../../../../AppData/Local/Temp/Rar$DRa14036.14120/src/app/helper/alertTimer/alert-timer.service.ts"
></script>
<template>
  <!-- The Modal -->
  <div
      id="editModal"
      class="modal"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <!-- Modal Header -->
        <div class="modal-header">
          <button
              type="button"
              class="close"
              data-dismiss="modal"
          >
            &times;
          </button>
        </div>
        <!-- Modal body -->
        <div class="">
          <!--Start-->
          <b-card-code
              title="Edit Payment"
          >
            <!-- form -->
            <validation-observer ref="simpleRules">
              <b-form>
                <b-row>
                  <b-col md="6">
                    <b-form-group>
                      <label for="title">Title</label>
                      <validation-provider
                          #default="{ errors }"
                          name="title"
                          rules="required"
                      >
                        <b-form-input
                            id="title"
                            v-model="editedPayment.title"
                            name="title"
                            :state="errors.length > 0 ? false:null"
                            placeholder=""
                        />

                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group>
                      <label for="title">Price</label>
                      <validation-provider
                          #default="{ errors }"
                          name="price"
                          rules="required"
                      >
                        <b-form-input
                            id="price"
                            type="number"
                            step="0.01"
                            v-model="editedPayment.price"
                            name="price"
                            :state="errors.length > 0 ? false:null"
                            placeholder=""
                        />

                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="12">
                    <b-form-group>
                      <label for="title">Reference Number</label>
                      <validation-provider
                          #default="{ errors }"
                          name="referenceNumber"
                          rules="required"
                      >
                        <b-form-input
                            id="referenceNumber"
                            v-model="editedPayment.referenceNumber"
                            name="referenceNumber"
                            :state="errors.length > 0 ? false:null"
                            placeholder=""
                        />

                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="12">
                    <b-form-group>
                      <label for="name">Pyment Method</label>
                      <validation-provider
                          #default="{ errors }"
                          name="referenceNumber"
                          rules="required"
                      >
                        <v-select
                            class="parent-ownership"
                            v-model="editedPayment.payment_method_id"
                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            :options="paymentMethods"
                            :reduce="name => name.id"
                            label="name"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="12">
                    <b-form-group>
                      <label for="title">Date</label>
                      <validation-provider
                          #default="{ errors }"
                          name="date"
                          rules="required"
                      >
                        <b-form-datepicker
                            id="startDate"
                            v-model="editedPayment.date"
                            :class="errors&&errors.length > 0 ? 'is-invalid' : 'valid'"
                            menu-class="w-100"
                            calendar-width="100%"
                        />

                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="12">
                    <b-form-group>
                      <label for="title">File</label>
                      <a
                          v-if="payment && payment.file"
                          :href="payment && payment.file && payment.file.url"
                          target="_blank"
                      ><small style=" float: right;">View Old File?</small></a>
                      <validation-provider
                          #default="{ errors }"
                          name="file"
                          rules=""
                      >
                        <b-form-file
                            ref="file"
                            v-model="editedPayment.file"
                            :file-name-formatter="formatNames"
                            accept=".pdf"
                        />

                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="12">
                    <b-form-group>
                      <label for="note">Note «<span class="text-muted">English</span>»</label>
                      <validation-provider
                          #default="{ errors }"
                          name="Note"
                          rules=""
                      >
                        <template>
                          <b-form-textarea
                              id="note"
                              v-model="editedPayment.note"
                              :class="errors&&errors.length > 0 ? 'is-invalid' : 'valid'"
                              placeholder=""
                              rows="5"
                              cols="12"
                          />
                        </template>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="12">
                    <b-form-group>
                      <label for="noteAR">Note «<span class="text-muted">Arabic</span>»</label>
                      <validation-provider
                          #default="{ errors }"
                          name="Note AR"
                          rules=""
                      >
                        <template>
                          <b-form-textarea
                              id="noteAR"
                              v-model="editedPayment.noteAR"
                              class="arabic-font"
                              :class="errors&&errors.length > 0 ? 'is-invalid' : 'valid'"
                              placeholder=""
                              rows="5"
                              cols="12"
                              :dir="'rtl'"
                          />
                        </template>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>
                <!-- Modal footer -->
                <div class="modal-footer">
                  <button
                      type="button"
                      class="btn btn-primary"
                      @click.prevent="validationForm"
                  >
                    Submit
                  </button>
                </div>
              </b-form>
            </validation-observer>

            <template #code>
              {{ codeMultiple }}
            </template>
          </b-card-code>
          <!--End-->
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import BCardCode from '@core/components/b-card-code'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BFormInput, BFormGroup, BForm, BRow, BCol, BFormTextarea, BFormFile, BFormDatepicker

} from 'bootstrap-vue'
import {
  required, email, confirmed, password,
} from '@validations'
import vSelect from 'vue-select'
import vue2Dropzone from 'vue2-dropzone'
import { codeMultiple, codeBasic } from './code'
import FormTextAreaDefault from '../../../../../shared/form-textarea/FormTextAreaDefault.vue'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import invoiceService from '@/services/invoiceService'
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import paymentService from '@/services/paymentService'

export default {
  components: {
    BCardCode,
    ValidationProvider,
    ValidationObserver,

    BFormFile,
    BFormDatepicker,
    BFormInput,
    BFormGroup,
    BForm,
    BRow,
    BCol,
    BFormTextarea,
    FormTextAreaDefault,
    vSelect,
    vueDropzone: vue2Dropzone,
  },
  props: ['payment'],
  data() {
    return {
      paymentMethods: [],
      editedPayment: {
        referenceNumber: '',
        title: '',
        price: '',
        payment_method_id: '',
        date: '',
        file: null,
        note: '',
        noteAR: '',
      },
      PasswordValue: '',
      passwordCon: '',
      required,
      password,
      email,
      confirmed,
      codeMultiple,
      dropzoneOptions: {
        url: 'https://httpbin.org/post',
        addRemoveLinks: true,
        dictRemoveFile: 'Remove',
        maxFiles: 1,
      },
      codeBasic,
      selected: '',
    }
  },
  mounted() {
    this.getMethods()
    this.$watch(() => this.payment, payment => {
      console.log('====>', payment)
      this.editedPayment= {
            referenceNumber: payment.referenceNumber,
            title: payment.title,
            payment_method_id: payment.paymentMethod.id,
            price: parseFloat(payment.price),
            date: payment.date,
            file: null,
            note: payment.note,
            noteAR: payment.noteAR,
      }
    })
  },
  methods: {
    getMethods() {
      this.loading = true
      paymentService.getPaymentMethods().then(response => {
        this.paymentMethods = response.data.data
        console.log(response.data.data)
        this.loading = false
      })
    },
    formatNames(files){
      if (files.length === 1) {
        return files[0].name
      }
      return `${files.length} files selected`
    },
    validationForm() {
      console.log('editedPayment', this.editedPayment)
      this.$refs.simpleRules.validate()
          .then(success => {
            if (success) {

              paymentService.put(this.$route.params.id, this.payment.id, this.editedPayment)
                  .then(response => {
                    this.$emit('refresh', 'true')
                    this.editedPayment= {
                      reference_number: '',
                      title: '',
                      price: '',
                      payment_method_id: '',
                      date: '',
                      file: null
                    }
                    $('#editModal') .modal('hide')

                    if(response && response.status === 200){
                      this.$toast({
                        component: ToastificationContent,
                        position: 'top-right',
                        props: {
                          title: 'Success',
                          icon: 'CheckIcon',
                          variant: 'success',
                          text: `Payment Is Updated Successfully !`,
                        },
                      })
                    }

                    this.loading = false
                    console.log('testing')
                  })
            }})
          .catch(
              function (error) {
                console.log('Show error notification!', error)
                $('#editModal').modal('hide')
                this.$toast({
                  component: ToastificationContent,
                  position: 'top-right',
                  props: {
                    title: 'Success',
                    icon: 'CheckIcon',
                    variant: 'Error',
                    text: `Error !`,
                  },
                })
                return Promise.reject(error)
              }
          )
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

label {
  font-weight: bold;
}
</style>
